import React from 'react';
import { Autocomplete } from '@material-ui/lab';

import { LabelEnum } from 'app/shared/enums';
import { AutoSuggestAutocompleteProps } from './AutoSuggestAutocomplete.interface';
import { useAutoSuggestAutocomplete } from './useAutoSuggestAutocomplete';
import { useStyles } from './AutoSuggestAutocomplete.styles';

export default function AutoSuggestAutocomplete(
  props: AutoSuggestAutocompleteProps
) {
  const classes = useStyles(props);
  const { autoHighlight = true, disablePortal = true } = props;
  const { listboxProps } = useAutoSuggestAutocomplete();

  return (
    <Autocomplete
      {...props}
      freeSolo
      className={classes.autoComplete}
      classes={{
        endAdornment: classes.autoCompleteEndAdornment,
        inputRoot: classes.autoCompleteInputRoot,
        listbox: classes.autoCompleteListbox,
        option: classes.autoCompleteOption,
        paper: classes.autoCompletePaper,
        popperDisablePortal: classes.autoCompletePopper,
      }}
      clearText={LabelEnum.Clear}
      autoHighlight={autoHighlight}
      disablePortal={disablePortal}
      ListboxProps={listboxProps}
    />
  );
}
